import { createContextForController } from 'react-controller-context';
import { useState } from 'react';

interface ISnackState {
  isOpen: boolean;
  isError?: boolean;
  isWarning?: boolean;
  isSuccess?: boolean;
  message: string;
}

const useActionNotification = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [alertState, setAlertState] = useState<ISnackState | null>(null);

  const showErrorMessage = (s: string) => {
    setErrorMessage(s);
  };

  const clearErrorMessage = () => setErrorMessage(null);

  const displaySuccessAlert = (s: string) => {
    setAlertState({
      isOpen: true,
      isSuccess: true,
      message: s
    });
  };

  const displayWarningAlert = (s: string) => {
    setAlertState({
      isOpen: true,
      isWarning: true,
      message: s
    });
  };

  const displayErrorAlert = (s: string) => {
    setAlertState({
      isOpen: true,
      isError: true,
      message: s
    });
  };

  const clearAlert = () => setAlertState(null);

  return {
    errorMessage,
    alertState,
    showErrorMessage,
    displaySuccessAlert,
    displayWarningAlert,
    displayErrorAlert,
    clearErrorMessage,
    clearAlert
  };
};

export const actionNotification = createContextForController(useActionNotification);
